import { SecurityAccessFeaturesEnum } from 'bff';
import { LoadingPage } from 'components/molecules/loading-page/LoadingPage';
import { NoAccess } from 'modules/app/components/pages/no-access/NoAccess';
import { useUserContext } from 'providers/managers/user-context-manager/user-context-manager';
import React from 'react';

type RouteGuardProps = {
  component: React.ReactNode;
  features: SecurityAccessFeaturesEnum[];
};

export const RouteGuard = ({ component, features }: RouteGuardProps) => {
  const userContext = useUserContext();
  const currentUser = userContext.getCurrentAuthenticatedUserWithFeatures();

  if (!currentUser) return <LoadingPage />;

  const isFeaturesAllowed = userContext.canAccessAny(features);

  if (isFeaturesAllowed) return <>{component}</>;

  return <NoAccess />;
};
